import React from "react";
import { useNavigate } from "react-router-dom";

export default function ToHome() {

    const nav = useNavigate()

    return nav('/individualAcc', { replace: true });
}
